import { Action } from "@ngrx/store";
import { Cell, ReportCache } from "core-lib";
import { Verbatims, DriverData2, LinescoreTabData, LinescoreData, DriverData } from "../../models";

export const LOAD_VERBATIMS = '[VERBATIMS] Load Verbatims';
export const LOAD_VERBATIMS_FAIL = '[VERBATIMS] Load Verbatims Fail';
export const LOAD_VERBATIMS_SUCCESS = '[VERBATIMS] Load Verbatims Success';

export const LOAD_LINESCORE = '[LINESCORE] Load Linescore Data';
export const LOAD_LINESCORE_FAIL = '[LINESCORE] Load Linescore Data Fail';
export const LOAD_LINESCORE_SUCCESS = '[LINESCORE] Load Linescore Data Success';

export const LOAD_BRANDS_DATA = '[BRANDS] Load Brands Data';
export const LOAD_BRANDS_DATA_FAIL = '[BRANDS] Load Brands Data Fail';
export const LOAD_BRANDS_DATA_SUCCESS = '[BRANDS] Load Brands Data Success';

export const LOAD_OTHER = '[OTHER] Load Other Data';
export const LOAD_OTHER_FAIL = '[OTHER] Load Other Data Fail';
export const LOAD_OTHER_SUCCESS = '[OTHER] Load Other Data Success';

export const LOAD_DRIVER = '[DRIVER] Load Driver Data';
export const LOAD_DRIVER_FAIL = '[DRIVER] Load Driver Data Fail';
export const LOAD_DRIVER_SUCCESS = '[DRIVER] Load Driver Data Success';

export const LOAD_RATINGS = '[RATINGS] Load Ratings';
export const LOAD_RATINGS_FAIL = '[RATINGS] Load Ratings Fail';
export const LOAD_RATINGS_SUCCESS = '[RATINGS] Load Ratings Success';

export const CLEAR_DATA = '[REPORTS] Clear tabs data';
export const ARCHIVE_REPORT = '[REPORTS] Archive Report';
export const ARCHIVE_REPORT_SUCCESS = '[REPORTS] Archive Report Success';
export const ARCHIVE_REPORT_FAIL = '[REPORTS] Archive Report Fail';
export const DELETE_ARCHIVE = '[REPORTS] Delete Archive';
export const DELETE_ARCHIVE_SUCCESS = '[REPORTS] Delete Archive Success';
export const DELETE_ARCHIVE_FAIL = '[REPORTS] Delete Archive Fail';

export const LOAD_LINESCORES = '[REPORTS] Load Linescores';
export const LOAD_LINESCORES_FAIL = '[REPORTS] Load Linescores Fail';
export const LOAD_LINESCORES_SUCCESS = '[REPORTS] Load Linescores Success';

export const LOAD_ALL_DATA = '[REPORTS] Load All Data';

export const LOAD_CELL = '[Cell] Load Cell';
export const CELL_LOADED = '[Cell] Cell Loaded';
export const LOAD_CELL_FAIL = '[Cell] Load Cell Failed';

export class LoadCell implements Action {
    readonly type = LOAD_CELL;

    constructor(public payload: { surveyId: string, cache?: ReportCache }) { }
}

export class CellLoaded implements Action {
    readonly type = CELL_LOADED;

    constructor(public payload: Cell) { }
}

export class LoadCellFail implements Action {
    readonly type = LOAD_CELL_FAIL;

    constructor(public payload: any) { }
}

export abstract class ErrorAction implements Action {

    abstract type: string;
    abstract payload: { error: string };

}

export class DeleteArchive implements Action {
    readonly type = DELETE_ARCHIVE;

    constructor(public payload: { archiveId: string }) { }
}

export class DeleteArchiveSuccess implements Action {
    readonly type = DELETE_ARCHIVE_SUCCESS;

    constructor(public payload: any) { }
}

export class DeleteArchiveFail extends ErrorAction {
    readonly type = DELETE_ARCHIVE_FAIL;

    constructor(public payload: { error: string }) {
        super();
    }
}

export class LoadAllData implements Action {
    readonly type = LOAD_ALL_DATA;

    constructor(public payload: string) { }
}

export class LoadLinescores implements Action {
    readonly type = LOAD_LINESCORES;

    constructor(public payload: string) { }
}

export class LoadLinescoresFail implements Action {
    readonly type = LOAD_LINESCORES_FAIL;

    constructor(public payload: any) { }
}

export class LoadLinescoresSuccess implements Action {
    readonly type = LOAD_LINESCORES_SUCCESS;

    constructor(public payload: any) { }
}

export class ArchiveReport implements Action {
    readonly type = ARCHIVE_REPORT;

    /**
     * Create Archive. Invokes prompt for archive name
     * @param payload CacheKey
     */
    constructor(public payload: string) { }
}

export class ArchiveReportSuccess implements Action {
    readonly type = ARCHIVE_REPORT_SUCCESS;

    constructor(public payload: any) { }
}

export class ArchiveReportFail implements Action {
    readonly type = ARCHIVE_REPORT_FAIL;

    constructor(public payload: any) { }
}

export class ClearData implements Action {
    readonly type = CLEAR_DATA;
}

export class LoadRatings implements Action {
    readonly type = LOAD_RATINGS;

    constructor(public payload: string) { }
}

export class LoadRatingsFail implements Action {
    readonly type = LOAD_RATINGS_FAIL;

    constructor(public payload: any) { }
}

export class LoadRatingsSuccess implements Action {
    readonly type = LOAD_RATINGS_SUCCESS;

    constructor(public payload: any) { }
}

export class LoadDriver implements Action {
    readonly type = LOAD_DRIVER;

    /**
     * @description Load driver tab data for given cache key.
     * @param payload Report cache ID
     */
    constructor(public payload: string) { }
}

export class LoadDriverFail implements Action {
    readonly type = LOAD_DRIVER_FAIL;

    /**
     * @description Fired when driver request fails.
     * @param payload Error returned from request
     */
    constructor(public payload: any) { }
}

export class LoadDriverSuccess implements Action {
    readonly type = LOAD_DRIVER_SUCCESS;

    constructor(public payload: DriverData[]) { }
}

export class LoadVerbatims implements Action {
    readonly type = LOAD_VERBATIMS;

    constructor(public payload: string) { }
}

export class LoadVerbatimsFail implements Action {
    readonly type = LOAD_VERBATIMS_FAIL;

    constructor(public payload: any) { }
}

export class LoadVerbatimsSuccess implements Action {
    readonly type = LOAD_VERBATIMS_SUCCESS;

    constructor(public payload: Verbatims) { }
}

export class LoadLinescore implements Action {
    readonly type = LOAD_LINESCORE;

    constructor(public payload: string) { }
}

export class LoadLinescoreFail implements Action {
    readonly type = LOAD_LINESCORE_FAIL;

    constructor(public payload: any) { }
}

export class LoadLinescoreSuccess implements Action {
    readonly type = LOAD_LINESCORE_SUCCESS;

    constructor(public payload: LinescoreData) { }
}

export class LoadBrandsData implements Action {
    readonly type = LOAD_BRANDS_DATA;

    constructor(public payload: string) { }
}

export class LoadBrandsDataFail implements Action {
    readonly type = LOAD_BRANDS_DATA_FAIL;

    constructor(public payload: any) { }
}

export class LoadBrandsDataSuccess implements Action {
    readonly type = LOAD_BRANDS_DATA_SUCCESS;

    constructor(public payload: any) { }
}

export class LoadOther implements Action {
    readonly type = LOAD_OTHER;

    constructor(public payload: { cacheKey: string, crosstab: boolean }) { }
}

export class LoadOtherFail implements Action {
    readonly type = LOAD_OTHER_FAIL;

    constructor(public payload: any) { }
}

export class LoadOtherSuccess implements Action {
    readonly type = LOAD_OTHER_SUCCESS;

    constructor(public payload: any) { }
}

export type ReportsDataAction = LoadVerbatims | LoadVerbatimsFail | LoadVerbatimsSuccess | LoadLinescore | LoadLinescoreFail | LoadLinescoreSuccess | LoadBrandsData | LoadBrandsDataFail | LoadBrandsDataSuccess | LoadOther | LoadOtherFail | LoadOtherSuccess | LoadDriver | LoadDriverFail | LoadDriverSuccess | LoadRatings | LoadRatingsFail | LoadRatingsSuccess | ClearData | ArchiveReport | ArchiveReportFail | ArchiveReportSuccess | LoadLinescores | LoadLinescoresFail | LoadLinescoresSuccess | LoadAllData | DeleteArchive | DeleteArchiveFail | DeleteArchiveSuccess | LoadCell | CellLoaded | LoadCellFail;

export type ReportsErrorAction = LoadLinescoreFail | LoadBrandsDataFail | LoadDriverFail | LoadRatingsFail;